// ─── List Detail Route — PERMANENT back-compat alias (ADR 0012 D5) ───
// The canonical list detail page moved to `/app/l/$listRef` (friendly URL,
// Phase 6.5 item 2) — see routes/app/l/$listRef.tsx for the actual page,
// validateSearch, and loader flow this alias defers to.
//
// This file stays FOREVER so nothing already bookmarked with the old opaque
// `/app/spaces/{spaceId}/lists/{listId}` URL ever 404s: the loader resolves
// the list (scope-checked, identical to the canonical route's resolve call —
// just keyed by the raw id's short suffix instead of a parsed ref, since there
// is no slug in this URL shape) and issues a client-side "permanent" redirect
// to the canonical friendly URL, preserving every search param
// (`search: (prev) => prev` — ?view=/?openTask=/filters all survive the hop).
// `replace: true` so Back does not trap the user in a redirect loop.

import { createFileRoute, redirect } from '@tanstack/react-router';
import { shortId } from '@a8-planner/shared/utils/entity-url';
import { resolveEntity } from '../../../../../lib/entity-resolve';

export const Route = createFileRoute('/app/spaces/$spaceId/lists/$listId')({
  loader: async ({ params }): Promise<never> => {
    const resolved = await resolveEntity('list', shortId(params.listId));
    throw redirect({
      to: resolved.canonicalPath as '/app',
      search: (prev) => prev,
      replace: true,
    });
  },
});
